module.exports = __webpack_public_path__ + "img/logo.e440b8c4.png";